@if (!loading) {
<div class="box">
  <div class="page-header">
    <div>
      <p class="page-title">Device Tokens</p>
      <p class="page-desc">Device tokens represent registered user devices. Enable or disable tokens to control which devices can receive push notifications.</p>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon stat-icon--total">
        <mat-icon>devices</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ tokenCount }}</span>
        <span class="stat-label">Devices</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon stat-icon--active">
        <mat-icon>check_circle</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ activeTokens }}</span>
        <span class="stat-label">Active</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon stat-icon--pending">
        <mat-icon>block</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ disabledTokens }}</span>
        <span class="stat-label">Disabled</span>
      </div>
    </div>
  </div>

  <div class="table-toolbar">
    <mat-form-field class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search tokens…" />
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="row-icon"><mat-icon>smartphone</mat-icon></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Token">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Token</th>
        <td mat-cell *matCellDef="let element">{{ element.Token }}</td>
      </ng-container>

      <ng-container matColumnDef="PK">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.PK }}</td>
      </ng-container>

      <ng-container matColumnDef="CreationDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Creation Date</th>
        <td mat-cell *matCellDef="let element">{{ parseCreationDate(element.CreationDate) | date:'mediumDate' }}</td>
      </ng-container>

      <ng-container matColumnDef="Enabled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element">
          @if (element.Enabled) {
            <span class="status-badge status-badge--approved">
              <mat-icon>check_circle</mat-icon> Active
            </span>
          } @else {
            <span class="status-badge status-badge--disabled">
              <mat-icon>block</mat-icon> Disabled
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="action-btn" title="Edit"
                  (click)="openModal(element, 'Edit', true); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matNoDataRow>
        <td colspan="6">
          <div class="empty-state">
            <mat-icon>devices_other</mat-icon>
            <p>No tokens found</p>
          </div>
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          class="table-row" (click)="openModal(row, 'Edit', true)"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons aria-label="Select page">
  </mat-paginator>
</div>
} @else {
  <app-loading-spinner></app-loading-spinner>
}
